<template>
	<div class="max-w-6xl mx-auto px-8 pb-20">
		<div class="md:flex md:-mx-6">
			<div class="md:w-2/6 md:px-6 md:order-2 flex flex-col justify-center">
				<img :src="thanks.asset" />
			</div>
			<div class="md:w-4/6 md:px-6 md:order-1">
				<p
					class="type-1000 font-70 mb-10 md:mb-16 md:type-1200 text-secondary max-w-lg"
				>
					{{ thanks.heading }}
				</p>
				<div class="max-w-lg prose mb-10" v-html="thanks.subheading" />
				<button class="btn-primary w-full max-w-sm" @click="closeWindow">
					<slot></slot>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		thanks: {
			type: Object,
			required: true,
		},
	},
	methods: {
		closeWindow: function () {
			window.close()
		},
	},
}
</script>
